__turbopack_context__.v({
  "className": "spectral_cc507c56-module__cg51IG__className",
  "variable": "spectral_cc507c56-module__cg51IG__variable",
});
